import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"
import { cn } from "../../lib/utils"
const Checkbox = React.forwardRef<
 React.ElementRef<typeof CheckboxPrimitive.Root>,
 React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
 <CheckboxPrimitive.Root
 ref={ref}
 className={cn(
"peer h-4 w-4 shrink-0 rounded-sm border border-border-subtle bg-background ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring)/0.18)] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-muted disabled:border-border data-[state=checked]:border-transparent data-[state=checked]:bg-[hsl(var(--brand-accent))] data-[state=checked]:text-white",
 className
 )}
 {...props}
 >
 <CheckboxPrimitive.Indicator
 className={cn("flex items-center justify-center text-current")}
 >
 <Check className="h-4 w-4"/>
 </CheckboxPrimitive.Indicator>
 </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
